module.exports = __webpack_public_path__ + "img/01.1eba5c63.png";